
export class ValidationDetailSummary {

  constructor(
    public hash?: string,
    public subactivityHash?: string,
    public subactivityName?: string,
    public programHash?: string,
    public programReference?: string,
    public printHash?: string,
    public printReference?: string,
    public manufacturingOrderHash?: string,
    public manufacturingOrderCode?: string,
    public materialHash?: string,
    public materialCode?: string,
    public materialFileName?: string
  ) {}

  get isCompleted() {
    return this.programHash !== null && this.printHash !== null;
  }

  clone() {
    return new ValidationDetailSummary(
      this.hash,
      this.subactivityHash,
      this.subactivityName,
      this.programHash,
      this.programReference,
      this.printHash,
      this.printReference,
      this.manufacturingOrderHash,
      this.manufacturingOrderCode,
      this.materialHash,
      this.materialCode,
      this.materialFileName
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/validation-detail-summary.ts